"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageOneForcedContent;
var _react = _interopRequireDefault(require("react"));
var _Notebook = _interopRequireDefault(require("../svg/Notebook"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PageOneForcedContent() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_Notebook.default, {
    className: "align-top"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sideContent-smallTitle"
  }, "5 MINUTES TO COMPLETE"), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-top-0 mm-spacing--minor"
  }, "Quick Start"))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "rig-sideContent-ul"
  }, /*#__PURE__*/_react.default.createElement("li", null, "Enter your information in the calculator. If you have a partner, they can complete the calculator and together you can get a more complete picture of retirement.", ' '), /*#__PURE__*/_react.default.createElement("li", null, "To complete the calculator even faster, get your current monthly expenses ready and any pension or other expected retirement income.", ' '), /*#__PURE__*/_react.default.createElement("li", null, "Our calculation is just an estimate, not a guarantee. So even if you have an income gap, don\u2019t worry. We\u2019re here to help you find ways to close the gap and plan for the retirement you want.", ' ')));
}